import React from 'react';
import 'twin.macro';
import { useSchoolyearsTrash } from '@teetsh/app/src/containers/UserSettings/Trash/Schoolyears/useSchoolyearsTrash';
import { useRestoreSchoolyear } from '@teetsh/app/src/containers/UserSettings/Trash/Schoolyears/useRestoreSchoolyear';
import { RestorableList } from '@teetsh/app/src/containers/UserSettings/Trash/components/RestorableList';
import { RestorableSchoolyear } from '@teetsh/app/src/types/schoolyear';
import { useTranslation } from 'react-i18next';

function Details({ nbOfSchools }: RestorableSchoolyear) {
  const { t } = useTranslation(['userSettings']);

  return (
    <div tw="font-light">
      {t('userSettings:restore.list.nbOfSchools', { count: nbOfSchools })}
    </div>
  );
}

export function SchoolyearsRestorableList() {
  const { data = [] } = useSchoolyearsTrash();
  const restore = useRestoreSchoolyear();

  return (
    <RestorableList<RestorableSchoolyear>
      items={data}
      restore={restore}
      cardFileDetails={Details}
      tableFileDetails={({ row }) => Details(row.original)}
    />
  );
}
